import React, { useState } from 'react';
import { Dialog, DialogContent, TextField, Button, Typography } from '@mui/material';
import './ForgotPasswordStyles.css';

export default function ForgotPasswordInitial({ open, onClose, onSubmit }) {
    const [email, setEmail] = useState('');
    const [error, setError] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!email) {
            setError('Please enter your email address');
            return;
        }
        try {
            await onSubmit(email);
        } catch (err) {
            setError(err.message);
        }
    };

    return (
        <Dialog 
            open={open} 
            onClose={onClose} 
            maxWidth="sm" 
            fullWidth
            PaperProps={{
                sx: {
                    width: '100%',
                    maxWidth: '444px', // Match sign in dialog width
                    margin: '20px'
                }
            }}
        >
            <DialogContent className="forgot-password-dialog">
                <Typography className="forgot-password-title">
                    Reset Password
                </Typography>
                <Typography className="forgot-password-subtitle">
                    Enter your email address and we'll send you a code to reset your password
                </Typography>
                <form onSubmit={handleSubmit}>
                    <TextField
                        className="forgot-password-input"
                        label="Email"
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        error={!!error}
                        helperText={error}
                        required
                    />
                    <Button
                        type="submit"
                        className="forgot-password-button"
                    >
                        Reset Password
                    </Button>
                </form>
            </DialogContent>
        </Dialog>
    );
} 